/* istanbul ignore file */
import { useTokenProvider } from 'infrastructure/security/authentication/DefaultTokenProvider';
import CopyIcon from '@mui/icons-material/ContentCopyOutlined';
import { useAuthorization } from 'framework/authorization';
import { Tooltip } from 'framework/ui/mui-builder';
import IconButton from '@mui/material/IconButton';
import { copyToClipboard } from 'framework/ui/clipboard';

const CopyTokenButton = () => {
  const { getToken } = useTokenProvider();
  const { isGranted } = useAuthorization();
  const hasPermissions = isGranted('EMPLOYEE_COPY_JWT_TOKEN');

  const onClick = async () => {
    const token = await getToken();

    if (token) {
      copyToClipboard(token);
    }
  };

  if (!hasPermissions) {
    return null;
  }

  return (
    <>
      <IconButton onClick={onClick}>
        <Tooltip title="Copy JWT">
          <CopyIcon />
        </Tooltip>
      </IconButton>
    </>
  );
};

export default CopyTokenButton;
